<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-indigo-50 p-3 border-1 border-indigo-100 border-round-lg">
            <i class="pi pi-flag text-indigo-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white shadow-1">
            <div class="flex flex-column gap-3">
               <div class="flex align-items-center gap-2">
                  <i class="pi pi-info-circle text-indigo-500"></i>
                  <span class="font-semibold text-900">{{
                     'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.PREVIEW.CAMPAIGN_INFO' | translate
                  }}</span>
               </div>

               <div *ngIf="selectedCampaignDetails(); else noCampaignSelected" class="flex flex-column gap-3">
                  <div class="flex justify-content-between align-items-center">
                     <span class="text-600 text-sm"
                        >{{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.NAME' | translate }}:</span
                     >
                     <span class="text-900 font-medium">{{ selectedCampaignDetails()?.name }}</span>
                  </div>

                  <div class="flex justify-content-between align-items-center">
                     <span class="text-600 text-sm"
                        >{{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.TYPE' | translate }}:</span
                     >
                     <div class="text-900 font-medium flex align-items-center gap-2">
                        <i *ngIf="selectedCampaignDetails()?.type === 'drip'" class="pi pi-forward"></i>
                        <i *ngIf="selectedCampaignDetails()?.type === 'pill'" class="pi pi-bolt"></i>
                        {{ translatedType() }}
                     </div>
                  </div>

                  <div class="flex justify-content-between align-items-center">
                     <span class="text-600 text-sm"
                        >{{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.STATUS' | translate }}:</span
                     >
                     <div
                        [class]="
                           'px-2 py-1 border-round text-xs font-bold border-1 ' +
                           getStatusClass(selectedCampaignDetails()?.status)
                        "
                     >
                        {{
                           'DATA.COMMON.STATUS.' + (selectedCampaignDetails()?.status || 'draft')
                              | translate
                              | uppercase
                        }}
                     </div>
                  </div>

                  <p-divider></p-divider>

                  <div class="grid text-sm">
                     <div class="col-6 flex align-items-center gap-2">
                        <i class="pi pi-sitemap text-600"></i>
                        <span class="text-600">{{
                           'DATA.MODULES.CAMPAINGS.GENERIC_INFO.INPUTS.NUMBER_NODES' | translate
                        }}</span>
                        <span class="text-900 font-semibold">{{ totalNodeCount() }}</span>
                     </div>
                     <div class="col-3 flex align-items-center gap-2">
                        <i class="pi pi-mobile text-blue-600"></i>
                        <span class="text-600">SMS</span>
                        <span class="text-900 font-semibold">{{ smsNodeCount() }}</span>
                     </div>
                     <div class="col-3 flex align-items-center gap-2">
                        <i class="pi pi-envelope text-indigo-600"></i>
                        <span class="text-600">Email</span>
                        <span class="text-900 font-semibold">{{ emailNodeCount() }}</span>
                     </div>
                  </div>

                  <ng-container *ngIf="selectedCampaignDetails()?.bucket as b">
                     <p-divider></p-divider>
                     <div class="flex align-items-center justify-content-between gap-3 text-sm">
                        <div class="flex align-items-center gap-4">
                           <div class="flex align-items-center gap-2">
                              <i class="pi pi-calendar-plus text-600"></i>
                              <span class="text-600">{{
                                 'DATA.MODULES.CAMPAINGS.GENERIC_INFO.START_DAYS' | translate: { days: b.start }
                              }}</span>
                           </div>
                           <div class="flex align-items-center gap-2">
                              <i class="pi pi-calendar-minus text-600"></i>
                              <span class="text-600">{{
                                 'DATA.MODULES.CAMPAINGS.GENERIC_INFO.FINISH_DAYS' | translate: { days: b.finish }
                              }}</span>
                           </div>
                        </div>
                        <div class="flex align-items-center gap-2" *ngIf="phase()">
                           <i class="pi pi-box text-600"></i>
                           <p-chip class="mt-1" [label]="phase()?.name"></p-chip>
                        </div>
                     </div>
                  </ng-container>

                  <p-divider></p-divider>

                  <div class="flex justify-content-center mt-2">
                     <span
                        class="text-primary cursor-pointer hover:underline flex align-items-center gap-2 font-medium"
                        (click)="viewCampaign()"
                     >
                        <i class="pi pi-external-link"></i>
                        {{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.PREVIEW.VIEW_CAMPAIGN' | translate }}
                     </span>
                  </div>
               </div>

               <ng-template #noCampaignSelected>
                  <div class="p-3 bg-gray-50 border-round-lg text-500 text-sm italic">
                     {{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.TARGET_CAMPAIGN_HELP' | translate }}
                  </div>
               </ng-template>
            </div>
         </div>

         <p-messages severity="info" [closable]="false">
            <ng-template pTemplate>
               <div class="flex flex-row gap-3 py-2 px-1">
                  <i class="pi pi-flag text-2xl"></i>
                  <div class="flex flex-column gap-1">
                     <span class="font-bold">
                        {{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.TITLE' | translate }}
                     </span>
                     <span class="line-height-3">
                        {{
                           'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.PREVIEW.SUMMARY_TEXT'
                              | translate: { campaignName: selectedCampaignDetails()?.name || '...' }
                        }}
                     </span>
                  </div>
               </div>
            </ng-template>
         </p-messages>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 overflow-visible pb-4">
      <div class="flex flex-column gap-5 overflow-visible">
         <div class="flex flex-column gap-3 overflow-visible">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{
                  'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.TARGET_CAMPAIGN_LABEL' | translate
               }}</span>
               <span class="text-sm text-500">{{
                  'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.TARGET_CAMPAIGN_HELP' | translate
               }}</span>
            </div>

            <div class="overflow-visible">
               <app-tree-select
                  *ngIf="campaignOptions()?.length"
                  [nodes]="campaignOptions()"
                  [selectedKeys]="selectedCampaignId() ? [selectedCampaignId()!] : []"
                  [placeholder]="'Selecciona la campaña a la que se asignará el expediente al llegar a este nodo'"
                  [enableSearch]="true"
                  (selectionChange)="onCampaignSelectionChange($event)"
               ></app-tree-select>
            </div>

            <div *ngIf="this.selectedCampaignId()" class="flex justify-content-end mt-1">
               <a
                  class="text-xs text-blue-600 cursor-pointer hover:text-blue-800 font-medium no-underline flex align-items-center gap-1"
                  (click)="viewCampaign()"
               >
                  <i class="pi pi-external-link"></i>
                  {{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.PREVIEW.VIEW_CAMPAIGN' | translate }}
               </a>
            </div>
         </div>

         <div *ngIf="selectedCampaignDetails()" class="flex flex-column gap-3">
            <span class="font-semibold text-900">{{
               'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.CAMPAIGN_DETAILS' | translate
            }}</span>
            <div class="surface-card p-4 border-1 border-round-xl border-200 bg-white flex flex-column gap-3">
               <div class="flex justify-content-between align-items-center">
                  <span class="text-600 text-sm"
                     >{{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.NAME' | translate }}:</span
                  >
                  <span class="text-900 font-medium">{{ selectedCampaignDetails()?.name }}</span>
               </div>
               <div class="flex justify-content-between align-items-center">
                  <span class="text-600 text-sm"
                     >{{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.TYPE' | translate }}:</span
                  >
                  <div class="text-900 font-medium flex align-items-center gap-2">
                     <i *ngIf="selectedCampaignDetails()?.type === 'drip'" class="pi pi-forward"></i>
                     <i *ngIf="selectedCampaignDetails()?.type === 'pill'" class="pi pi-bolt"></i>
                     {{ translatedType() }}
                  </div>
               </div>
               <div class="flex justify-content-between align-items-center">
                  <span class="text-600 text-sm"
                     >{{ 'DATA.MODULES.INSPECTORS.ASSIGN_CAMPAIGN.CONFIG.STATUS' | translate }}:</span
                  >
                  <div
                     [class]="
                        'px-2 py-1 border-round text-xs font-bold border-1 ' +
                        getStatusClass(selectedCampaignDetails()?.status)
                     "
                  >
                     {{
                        'DATA.COMMON.STATUS.' + (selectedCampaignDetails()?.status || 'draft') | translate | uppercase
                     }}
                  </div>
               </div>

               <p-divider></p-divider>

               <div class="grid text-sm">
                  <div class="col-6 flex align-items-center gap-2">
                     <i class="pi pi-sitemap text-600"></i>
                     <span class="text-600">{{
                        'DATA.MODULES.CAMPAINGS.GENERIC_INFO.INPUTS.NUMBER_NODES' | translate
                     }}</span>
                     <span class="text-900 font-semibold">{{ totalNodeCount() }}</span>
                  </div>
                  <div class="col-3 flex align-items-center gap-2">
                     <i class="pi pi-mobile text-blue-600"></i>
                     <span class="text-600">SMS</span>
                     <span class="text-900 font-semibold">{{ smsNodeCount() }}</span>
                  </div>
                  <div class="col-3 flex align-items-center gap-2">
                     <i class="pi pi-envelope text-indigo-600"></i>
                     <span class="text-600">Email</span>
                     <span class="text-900 font-semibold">{{ emailNodeCount() }}</span>
                  </div>
               </div>

               <ng-container *ngIf="selectedCampaignDetails()?.bucket as b">
                  <p-divider></p-divider>
                  <div class="flex align-items-center justify-content-between gap-3 text-sm">
                     <div class="flex align-items-center gap-4">
                        <div class="flex align-items-center gap-2">
                           <i class="pi pi-calendar-plus text-600"></i>
                           <span class="text-600">{{
                              'DATA.MODULES.CAMPAINGS.GENERIC_INFO.START_DAYS' | translate: { days: b.start }
                           }}</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                           <i class="pi pi-calendar-minus text-600"></i>
                           <span class="text-600">{{
                              'DATA.MODULES.CAMPAINGS.GENERIC_INFO.FINISH_DAYS' | translate: { days: b.finish }
                           }}</span>
                        </div>
                     </div>
                     <div class="flex align-items-center gap-2" *ngIf="phase()">
                        <i class="pi pi-box text-600"></i>
                        <p-chip class="mt-1" [label]="phase()?.name"></p-chip>
                     </div>
                  </div>
               </ng-container>
            </div>
         </div>

         <p-divider></p-divider>

         <p-messages *ngIf="errors().length > 0" severity="error">
            <ng-template pTemplate="content">
               <div class="flex flex-column gap-1">
                  <div *ngFor="let error of errors()">
                     {{ getErrorMessage(error) }}
                  </div>
               </div>
            </ng-template>
         </p-messages>
      </div>
   </div>
</div>
